var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20 9a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zm0 2h-9v9h9zm-6-9a2 2 0 0 1 2 2v2a1 1 0 1 1-2 0V4H4v10h2a1 1 0 1 1 0 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }